export const routeFormatter = (string?: string) => (string || '').replace('Россия, ', '')

const FALLBACK_CURRENCY = 'RUB'

export const localizePrice = (
  price: string | number,
  currency: string = FALLBACK_CURRENCY,
  locale: string = 'ru-RU',
): string => {
  const value = typeof price === 'string' ? parseFloat(price) : price

  try {
    return value.toLocaleString(locale, {style: 'currency', currency}).replace(',00', '')
  } catch (err) {
    //если пришел невалидный currency код, то покажем валюту рубли
    return value.toLocaleString(locale, {style: 'currency', currency: FALLBACK_CURRENCY}).replace(',00', '')
  }
}
